import { pageRoutes } from "../../../../routes";
import EntitiesListPage from "../../../entityFields/grid/EntitiesListPage";

const VendorsPage = () => {
  return (
    <EntitiesListPage
      objectType="Vendor"
      objectDetailsPathPattern={`/:clientCode/${pageRoutes.expenseManagement}/${pageRoutes.vendors}/:id`}
      objectsTitle="Vendors"
      allowCreate
    />
  );
};

export default VendorsPage;
